/**
 * The Network Topology address that opens on a VPC (and optionally one of its subnets).
 * One builder for the handlers that navigate there and the "Add view" gestures that
 * need the same address before anything is clicked (project 13D).
 */
export interface TopologyTarget {
  id: string;
  cloud: string;
  region: string;
  accountId?: string | null;
  compartmentId?: string | null;
}

export function topologyPath(vpc: TopologyTarget, subnetId?: string): string {
  const params = new URLSearchParams();
  params.set("provider", vpc.cloud);
  params.set("region", vpc.region);
  if (vpc.cloud === "aws" && vpc.accountId) {
    params.set("account", vpc.accountId);
  } else if (vpc.cloud === "oci" && vpc.compartmentId) {
    params.set("account", vpc.compartmentId);
  }
  params.set("vpc", vpc.id);
  if (subnetId) params.set("subnet", subnetId);
  return `/insight/topology?${params.toString()}`;
}
